import { Component, viewChild } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  DatePipe,
  FormComponent,
  FormRowComponent,
  InputDirective,
  InputErrorsComponent,
  InputGroupComponent,
  InputGroupFieldComponent,
  InputGroupLabelComponent,
  NotificationComponent
} from '@tdwb/core';
import { AgreementsDateBaseDirective } from '../agreements.base';

export interface NyseAgreementFormModel {
  clientName: string,
  clientAddress: string,
  clientOccupation: string,
  clientEmployerNameAddress: string,
  clientTitlePosition: string,
  clientEmployerFunction: string
}

@Component({
  selector: 'td-wb-nyse-agreement',
  templateUrl: './nyse-agreement.component.html',
  styleUrls: ['../agreements.component.scss'],
  imports: [
    NgTemplateOutlet,
    FormsModule,
    NotificationComponent,
    DatePipe,
    FormComponent,
    FormRowComponent,
    InputGroupComponent,
    InputGroupLabelComponent,
    InputGroupFieldComponent,
    InputDirective,
    InputErrorsComponent
  ]
})
export class NyseAgreementComponent extends AgreementsDateBaseDirective {

  protected readonly form = viewChild(FormComponent);

  formModel: NyseAgreementFormModel = {
    clientName: '',
    clientAddress: '',
    clientOccupation: '',
    clientEmployerNameAddress: '',
    clientTitlePosition: '',
    clientEmployerFunction: ''
  };

  trySubmitAndReturnModel(): NyseAgreementFormModel {
    const form = this.form();
    return form !== undefined && super.trySubmit(form) ? this.formModel : undefined;
  }

}
